export const VENDOR_TYPES = [
  { value: "supplier", label: "Supplier" },
  { value: "subcontractor", label: "Subcontractor" },
  { value: "service", label: "Service" },
  { value: "rental", label: "Rental" },
];

export const vendorTypeLabel = (v) => VENDOR_TYPES.find((t) => t.value === v)?.label || v;
